import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../types/base-tool-types';

const toolName = 'list-workflow-executions' as const;

const argumentZod = z.object({
  workflow_id: z
    .string()
    .describe('Unique identifier of the workflow to list executions for.'),
  limit: z
    .number()
    .int()
    .min(1)
    .max(10)
    .optional()
    .describe('Maximum number of executions to return. Defaults to 5.'),
  offset: z
    .number()
    .int()
    .min(0)
    .optional()
    .describe(
      'Number of executions to skip for pagination. Use with hasMore to fetch subsequent pages.'
    ),
});

export const listWorkflowExecutionsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List workflow executions',
  family: 'workflows',
  llmTool: {
    name: toolName,
    description:
      'Lists recent executions of an AI workflow, including their status and output. Use this to retrieve results generated by a workflow (e.g. a content brief, copy, or other generated content). Returns executions ordered from most recent to oldest.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AIA_WORKFLOWS_MCP,
  confirmBeforeExecuting: false,
});

export type ListWorkflowExecutionsArgumentType = z.infer<typeof argumentZod>;
